import angular from 'angular';
import Vue from 'vue';
import 'ngVue';

import SchedulingDashboard from './SchedulingDashboard.vue';

export default angular
  .module('directives.schedulingdashboard', [])
  .directive('dcSchedulingDashboard', [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('DcSchedulingDashboard', SchedulingDashboard));
    }
  ]);
